import {
  Component,
  effect,
  EventEmitter,
  Input,
  Output,
  Signal,
  signal,
  inject,
} from '@angular/core';

import { FormGroup, FormsModule } from '@angular/forms';
import { DynamicFormField } from '../../form/formulary';
import { BaseConnection } from '../conection-factory';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { FormBuilderService } from '../../services/form-builder.service';
import { DynamicFormComponent } from '../../component/dynamic-form/dynamic-form.component';
import {
  Connection,
  ConnectionDataMap,
  ConnectionType,
} from '../../interfaces/connection-interface';
import { ConnectionStateService } from '../../services/connection-state.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-connection-form',
  standalone: true,
  imports: [FormsModule, DialogModule, ButtonModule, SelectModule, DynamicFormComponent],
  templateUrl: './connection-form.component.html',
  styleUrl: './connection-form.component.css',
})
export class ConnectionFormComponent {
  private formBuilder = inject(FormBuilderService);
  private connectionState = inject(ConnectionStateService);

  @Input() selectedType: ConnectionType = 'ftp';
  @Output() formSubmitted = new EventEmitter<ConnectionDataMap[ConnectionType]>();
  @Input() mode: 'create' | 'edit' = 'create';

  displayModal = signal(false);
  form!: FormGroup;
  fields: DynamicFormField[] = [];
  connection: Signal<Connection | null> = signal<Connection | null>(null);

  constructor() {
    this.connection = toSignal(this.connectionState.getCurrentConnection(), { initialValue: null });
    effect(() => {
      const conn = this.connection();
      if (conn) {
        this.fields = BaseConnection[conn.type];
        this.form = this.formBuilder.buildForm(this.fields, conn.data);
        this.displayModal.set(true);
      } else {
        this.displayModal.set(false);
      }
    });
  }

  getTitle(): string {
    return this.mode === 'create' ? 'Crear una nueva conexión' : 'Editar una conexión existente';
  }

  getButtonLabel(): string {
    return this.mode === 'create' ? 'Crear conexión' : 'Guardar cambios';
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.formSubmitted.emit(this.form.value);
      this.closeModal();
    } else {
      this.form.markAllAsTouched();
      this.formSubmitted.emit();
    }
  }

  openModal(connection: Connection): void {
    this.connectionState.setConnection(connection);
  }

  closeModal(): void {
    this.connectionState.setConnection(null);
  }
}
